import * as M from 'shared/types/models'; 

export function getStandardContent(content: any): M.StandardContent {
  return (content && typeof content === 'object') ? '' : content;
}
